export function Minus() {
  return (
    <svg
      aria-hidden={true}
      viewBox="0 0 82.713623046875 10.9873046875"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(1 0 0 1 -11.378203125000027 40.7236328125)">
        <path d="M17.8711-29.7363L88.6719-29.7363C91.6016-29.7363 94.0918-32.2266 94.0918-35.2051C94.0918-38.1836 91.6016-40.625 88.6719-40.625L17.8711-40.625C15.0391-40.625 12.4512-38.1836 12.4512-35.2051C12.4512-32.2266 15.0391-29.7363 17.8711-29.7363Z"></path>
      </g>
    </svg>
  );
}
